import { useMutation } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'Constants/env';
import API from '~/api';
import { TypingIndicatorState } from '../types/index.types';

export const MUTATION_KEY_UPDATE_TYPING_STATE =
  'typingIndicator.updateTypingState';

export type UpdateTypingStateParams = {
  conversationId: string;
  state: TypingIndicatorState;
};

/**
 * Updates the current user's typing state for a conversation.
 * PUT /conversations/{conversationId}/typing — returns 204.
 * Failures are non-critical and must not affect messaging.
 */
export const updateTypingState = async ({
  conversationId,
  state,
}: UpdateTypingStateParams): Promise<void> => {
  await API.put(API_ENDPOINTS.ConversationTyping(conversationId), { state });
};

/**
 * Mutation for sending `typing` / `stopped` to the backend.
 * Callers should fire-and-forget; do not surface errors to the user.
 */
export const useUpdateTypingState = () => {
  return useMutation({
    mutationKey: [MUTATION_KEY_UPDATE_TYPING_STATE],
    mutationFn: updateTypingState,
  });
};
